import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  callData: null,
};

const callSlice = createSlice({
  name: "call",
  initialState,
  reducers: {
    setCallData: (state, action) => {
      state.callData = action.payload;
    },
    removeCallData: (state) => {
      state.callData = null;
    },
  },
});

export const { setCallData, removeCallData } = callSlice.actions;
export default callSlice.reducer;
